export const RodneCislo2026 = (label: string) => ({
  type: 'input',
  props: {
    label: label,
    placeholder: 'XXXXXX/XXXX'
  },
  validators: {
    validation: [{ name: 'validateRodneCislo' }]
  }
});

export const specialCharsParser2026 = (value: string | null | undefined) => {
  if (!value) return value;
  value = value.replace(/[\t\r\n]/g, '');
  value = value.trim();
  return value;
};
